import React from 'react'
import './hower.css'

const Hower = (props) => {

  const {gif1,gif2} = props.gif

  return (
 <div>
      <div
        className="w"
        style={{
          background: `rgba(66, 66, 66, 0.5) url(${gif1}) repeat fixed`,
        }}
      >
        {[...Array(50)].map((_, index) => (
          <div
            className="i"
            key={index}
            style={{
              background: `rgba(75, 39, 217, 0.5) url(${gif2}) repeat fixed`,
            }}
          />
        ))}

        <div className="h">
          <h1 className='title'>Welcome to Our Learning Platform</h1>
        </div>
      </div>
      {/* <iframe src="https://assets.pinterest.com/ext/embed.html?id=912260468297453734" height="438" width="600" frameborder="0" scrolling="no" ></iframe> */}
    </div>
  )
}

export default Hower